<template>
  <div class="about-us" id="about-us">
    <div class="container">
      <h1 class="section-title text-center">
        About
        <u>Us</u>
      </h1>
      <p
        class="section-text text-center pt-5"
      >Ad Pad Pvt. Ltd. is a full-service media strategy, planning and buying agency having its office at Thapagaun, Kathmandu with maximum in-house facilities such as Audio/visual studio equipped with advanced equipment and editing table. We stand out with quality and qualification focusing on media marketing.</p>
      <p class="section-text text-center">
        We consider station formats, pricing rates, demographics, geographic, and psychographics relating to the advertiser's particular product.
        All media inventory goes through phases of optimization, which is dependent on budget, type of medium (radio, internet, TV, print etc.), target audience and targeting. Adpad keeps you ahead in the technology revolution, with advanced media planning tools that uncover deep data insights about the people who buy your products or services.
      </p>
      <p
        class="section-text text-center"
      >We extend your messaging across all the latest channels, screens and devices to get you in front of your most valuable audiences — wherever they are paying attention.</p>

      <div class="d-flex justify-content-center">
        <a href="#" v-scroll-to="'#achievements'">
          <div class="form-group program-btn">
            <i class="fas fa-images mr-2"></i>
            Our Achievements
          </div>
        </a>
      </div>
    </div>
  </div>
</template>


<script>
export default {};
</script>


<style scoped>
.about-us {
  padding: 60px 0;
  border-top: 1px solid #e5e5e5;
}

.program-btn {
  font-size: 16px;
  text-transform: uppercase;
  border: 3px solid #111111;
  padding: 9px 20px;
  color: #111111;
  cursor: pointer;
  display: inline-block;
  margin-top: 20px;
  font-weight: bold;
}

.program-btn i {
  font-size: 20px;
}
</style>